//#region Styles
import {
    Part, 
    TitleSection, 
    ParagraphSection, 
    Fields, 
    Row 
} from "components/styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
//#endregion

const Part1 = ({
    form, 
    changeField
}) => {
    //#region Functions
    const toggleStandOutEvent = () => {
        changeField("standOutAcadReinforce", !form.standOutAcadReinforce);
    }
    const changeDescriptionField = (value) => {
        changeField("description", value);
    }
    //#endregion
    return (
        <Part>
            <TitleSection>Información del refuerzo</TitleSection>
            <ParagraphSection>
                Añade la información que consideres necesaria:
            </ParagraphSection>
            <Fields>
                <CustomTextArea 
                    label="Descripción (opcional)"
                    placeholder="Escriba la descripción del refuerzo..."
                    value={form.description}
                    onChange={changeDescriptionField}
                    maxLength={250}
                    width="50%"/>
                <Row className="flex-start">
                    <CustomCheckbox
                        label="Destacar refuerzo" 
                        variant="switch"
                        checked={form.standOutAcadReinforce}
                        onChange={toggleStandOutEvent}/>
                    <ParagraphSection>
                        Al activarlo, le aparecerá al estudiante en su lista de refuerzos académicos.
                    </ParagraphSection>
                </Row>
            </Fields>
        </Part>
    );
}

export default Part1;